import { TypographyStyled } from 'pages/Finance/RefundChargebackReport/RefundChargebackReportSummary/RefundChargebackReportSummary.styled';
import { useGetOne, useRecordContext } from 'react-admin';
import { MerchantAccount } from 'types/embedded/merchantAccount';
import { RefundChargebackReportSummaryMerchantAccount } from 'types/embedded/refundChargebackReport';
import { convertReactAdminIdToHydraId } from 'utils';

type Props = {
  label: string;
  onClick: (record?: MerchantAccount) => void;
  source?: string;
};

export const RefundChargebackReportSummaryMerchantAccountField: React.FC<Props> = ({ onClick }) => {
  const record = useRecordContext<RefundChargebackReportSummaryMerchantAccount>();
  const { data: merchantAccount } = useGetOne<MerchantAccount>('merchant_accounts', {
    id: record && convertReactAdminIdToHydraId(record?.id, 'merchant_accounts'),
  });

  return (
    <TypographyStyled onClick={() => onClick(merchantAccount)}>{record?.name}</TypographyStyled>
  );
};
